/** Single source for main menu tiles — dashboard + design canvas */
export const WMS_HOME_TILES = [
  { key: "listing", labelKey: "home.tiles.listing", icon: "listing.png" },
  { key: "transactions", labelKey: "home.tiles.transactions", icon: "transaction.png" },
  { key: "stock", labelKey: "home.tiles.stock", icon: "stock.png" },
  { key: "import", labelKey: "home.tiles.import", icon: "import.png" },
  { key: "settings", labelKey: "home.tiles.settings", icon: "settings.png" },
  { key: "analytics", labelKey: "home.tiles.analytics", icon: "monitor-icon.png" },
];
